import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const DEFAULT_CURRENCY_FORMAT_PARAMS = {
  formatAsNegative: false,
  keepFractionDigits: true
};
const NO_FRACTION_DIGITS_CURRENCY_OPTIONS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
};

const formatCurrency = (rawValue, props, params) => {
  const {
    locale,
    currency
  } = props;

  const {
    formatAsNegative,
    keepFractionDigits
  } = _objectSpread(_objectSpread({}, DEFAULT_CURRENCY_FORMAT_PARAMS), params);

  const value = rawValue || 0;
  const numberValue = formatAsNegative ? Number(value) * -1 : Number(value);
  const fractionDigitsSetup = !keepFractionDigits && NO_FRACTION_DIGITS_CURRENCY_OPTIONS;
  return new Intl.NumberFormat(locale, _objectSpread({
    currency,
    style: 'currency',
    useGrouping: false
  }, fractionDigitsSetup)).format(numberValue);
};

const formatCurrencyAmount = (rawValue, locale, params) => {
  return formatCurrency(rawValue.amount, {
    locale,
    currency: rawValue.currencyCode
  }, params);
};

const formatAmount = (value, props) => {
  if (!value) return null;
  const decimalMaxLength = 3;
  let maxLength = 5;
  let formattedValue = value;
  if (formattedValue === '.') formattedValue = '0.00';
  if (props !== null && props !== void 0 && props.maxLength) ({
    maxLength
  } = props);
  formattedValue = formattedValue.replace(/,/g, '.');
  formattedValue = formattedValue.replace(/[^0-9.]/g, '');
  formattedValue = formattedValue.replace(/\.+/g, '.');
  formattedValue = formattedValue.replace(/(.*\.[0-9][0-9]?).*/g, '$1');
  formattedValue = formattedValue.replace(/^0+(.*)$/, '0$1');

  if (formattedValue.indexOf('.') !== -1) {
    let amount = formattedValue.substring(0, formattedValue.indexOf('.'));
    let cents = formattedValue.substring(formattedValue.indexOf('.'));

    if (amount.length > maxLength) {
      amount = amount.substring(0, maxLength);
    }

    if (cents.length > decimalMaxLength) {
      cents = cents.substring(0, decimalMaxLength);
    }

    formattedValue = "".concat(amount).concat(cents);
  } else if (formattedValue.length > maxLength) {
    if (formattedValue[maxLength + 1] === '.') {
      formatAmount(formattedValue, props);
    } else {
      formattedValue = formattedValue.substring(0, maxLength);
    }
  }

  return formattedValue;
};

const MAX_ISBN_LENGTH = 13;

const formatIsbn = value => {
  const cleanedValue = value.replace(/[^\d-x]+/gi, '');
  let numbers = 0;
  return cleanedValue.split('').reduce((acc, char) => {
    if (numbers === MAX_ISBN_LENGTH) return acc;
    if (char !== '-') numbers += 1;
    return acc + char;
  }, '');
};

export { formatCurrency, formatCurrencyAmount, formatAmount, formatIsbn };